'use strict';

// NOTE: in WP we use the WP intern jQuery version
// globally "export" jquery for our plugins
// import jQuery from 'jquery';

// import version from './lib/version';
import './polyfill/object-fit';
import 'foundation-sites/dist/js/foundation';

// ////////////////////////////////////////////////////////////
// track contact form 7 submissions
import './lib/analytics/cf7';

const _ = {
    shuffle: require('lodash.shuffle/index')
};

// ////////////////////////////////////////////////////////////
// init foundation
jQuery(($) => {
    const $menuButton = $('.menu-toggle .hamburger'),
        $offCanvasInner = $('.off-canvas-wrapper-inner'),
        $primaryNav = $('.primary-nav');

    $primaryNav.css('opacity', 1);

    $(document)
        .foundation()
        .on('opened.zf.offcanvas', () => {
            $menuButton.addClass('is-active');

            $offCanvasInner.addClass('js-off-canvas-opened');
            $offCanvasInner.removeClass('js-off-canvas-closed');
        })
        .on('closed.zf.offcanvas', () => {
            $menuButton.removeClass('is-active');

            $offCanvasInner.addClass('js-off-canvas-closed');
            $offCanvasInner.removeClass('js-off-canvas-opened');
        });

    $('[data-random]').each((index, el) => {
        let $el = $(el);

        $el.append(_.shuffle($el.children().toArray()))
            .addClass('is-init');
    });

    $('.js--history-back').on('click', function () {
        history.back();
    });

    $('.js--leading-slash').before('<span class="show-on-post"> / </span>');

    $('a').has('img').addClass('no-link-icon');

    // you can listen to breakpoint changes like so:
    // $(window).on('changed.zf.mediaquery', (event, current, old) => {
    //    console.log(`Breakpoint changed from "${old}" to "${current}"`);
    // });
});

// ////////////////////////////////////////////////////////////
// browser alerts
import oldBrowserAlert from './lib/alerts/old-browser';
oldBrowserAlert();

// ////////////////////////////////////////////////////////////
// scroll events
import scrollUp from '@spinnwerk/scroll-helper/scroll-up';
scrollUp();

// ////////////////////////////////////////////////////////////
// sliding header
import './lib/headroom';

// ////////////////////////////////////////////////////////////
// login button/form
import './lib/login';

// ////////////////////////////////////////////////////////////
// form helpers
import './lib/form/form';

// ////////////////////////////////////////////////////////////
// password-lost form
import './lib/passwordLost';

// ////////////////////////////////////////////////////////////
// modal
import './lib/modal';

// ////////////////////////////////////////////////////////////
// teaser
import './lib/teaser';

// ////////////////////////////////////////////////////////////
// table
import './lib/table';

// ////////////////////////////////////////////////////////////
// masonry
import './lib/layouts/masonry';

// ////////////////////////////////////////////////////////////
// swiper
import './lib/layouts/swiper';

// ////////////////////////////////////////////////////////////
// map
import './lib/layouts/map';

// ////////////////////////////////////////////////////////////
// cards
import cards from './lib/cards';
cards();



// WEBPACK FOOTER //
// ./resources/assets/js/app.js